export const SET_YEAR_LIST = "@home/SET_YEAR_LIST";
export const SET_SWIPE_HISTORY = "@home/SET_SWIPE_HISTORY";

